import { apiFetch } from './api';

const apiUrl = import.meta.env.VITE_API_URL;

interface ApiResponse<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

/** Inscrição do aparelho no aviso pelo navegador (Web Push). Quem recebe o quê é decidido na API. */
export const PushService = {
    /** A chave pública VAPID. Vazia = o ambiente não tem push configurado. */
    async chavePublica(): Promise<string> {
        const res = await apiFetch(`${apiUrl}/api/Push/ChavePublica`);
        const r: ApiResponse<{ chavePublica: string }> = await res.json();
        return r.sucesso ? (r.dados?.chavePublica ?? '') : '';
    },

    async inscrever(inscricao: PushSubscriptionJSON): Promise<boolean> {
        const res = await apiFetch(`${apiUrl}/api/Push/Inscrever`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                endpoint: inscricao.endpoint,
                p256dh: inscricao.keys?.p256dh ?? '',
                auth: inscricao.keys?.auth ?? '',
            }),
        });
        const r: ApiResponse<null> = await res.json();
        return r.sucesso;
    },

    async remover(endpoint: string): Promise<void> {
        await apiFetch(`${apiUrl}/api/Push/Remover`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ endpoint }),
        });
    },
};
